import { Splide } from "@splidejs/splide";

// needed for vite
import '../css/vendors.scss';
window["Splide"] = Splide;